module.exports = __webpack_public_path__ + "static/media/biking-mountain.c7cfc1ac.svg";